import classNames from 'classnames';
import { node, number, string } from 'prop-types';

import styles from './Content.module.scss';

export default function Content({ icon, className, text }) {
  return (
    <>
      <span
        className={classNames(styles.text, { [styles.bold]: icon }, className)}
      >
        {text}
      </span>
      {icon && (
        <img
          className={styles.icon}
          alt="icon"
          src={icon}
        />
      )}
    </>
  );
}

Content.propTypes = {
  icon: node,
  className: string,
  text: string || number,
};
